module.exports = __webpack_public_path__ + "fonts/proximanova-bold-webfont.2c8db067.ttf";